import { render, staticRenderFns } from "./home_plant.vue?vue&type=template&id=48255fce&scoped=true&"
import script from "./home_plant.vue?vue&type=script&lang=js&"
export * from "./home_plant.vue?vue&type=script&lang=js&"
import style0 from "./home_plant.vue?vue&type=style&index=0&id=48255fce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48255fce",
  null
  
)

export default component.exports